import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import React from "react";
import {
  useGetLeadDetailQuery,
  useUpdateLeadMutation,
} from "store/services/vendorLeadApi";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { VendorLeadForm } from "./vendorLeadComponents/VendorLeadForm";

export const VendorLeadEditScreen = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Leads", path: "/app/crm/vendor-lead/list" },
    { title: "Edit Lead" },
  ];

  const { data: vendorLeadDetail, isLoading: loadingVendorLeadDetail } =
    useGetLeadDetailQuery(id);

  const [updateLead, { isLoading: updatingLead }] = useUpdateLeadMutation();

  const handleUpdateLead = async (data) => {
    try {
      const res = await updateLead({ _id: id, ...data }).unwrap();
      toast.success("Lead updated successfully");
      navigate(`/app/crm/vendor-lead/${res?._id}/detail`);
    } catch (err) {
      toast.error(err?.data?.message ?? err?.message ?? "Couldn't update lead");
    }
  };

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={updatingLead || loadingVendorLeadDetail}
    >
      <BreadcrumbLayout.Paper>
        <VendorLeadForm
          onSubmit={handleUpdateLead}
          isBusy={updatingLead || loadingVendorLeadDetail}
          leadDetail={vendorLeadDetail}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};